export const ANALYTICS_CONSENT_STORAGE_KEY = 'radcore.analyticsConsent'
export const ANALYTICS_CONSENT_CHANGED_EVENT = 'radcore:analytics-consent-changed'

export type AnalyticsConsent = 'pending' | 'accepted' | 'declined'

export interface AnalyticsConsentStorage {
  getItem: (key: string) => string | null
  setItem: (key: string, value: string) => void
}

export function getAnalyticsConsent(storage: AnalyticsConsentStorage): AnalyticsConsent {
  const value = storage.getItem(ANALYTICS_CONSENT_STORAGE_KEY)
  return value === 'accepted' || value === 'declined' ? value : 'pending'
}

export function setAnalyticsConsent(
  storage: AnalyticsConsentStorage,
  consent: Exclude<AnalyticsConsent, 'pending'>
) {
  storage.setItem(ANALYTICS_CONSENT_STORAGE_KEY, consent)
}

export function getBrowserAnalyticsConsent(): AnalyticsConsent {
  if (typeof window === 'undefined') return 'pending'
  if (!window.localStorage) return 'pending'
  return getAnalyticsConsent(window.localStorage)
}

export function setBrowserAnalyticsConsent(consent: Exclude<AnalyticsConsent, 'pending'>) {
  if (typeof window === 'undefined') return
  if (!window.localStorage) return
  setAnalyticsConsent(window.localStorage, consent)
  window.dispatchEvent(new CustomEvent(ANALYTICS_CONSENT_CHANGED_EVENT, { detail: consent }))
}

export function shouldAskForAnalyticsConsent({
  analyticsConfigured,
  authenticated,
  loading,
  consent,
}: {
  analyticsConfigured: boolean
  authenticated: boolean
  loading: boolean
  consent: AnalyticsConsent
}) {
  return analyticsConfigured && authenticated && !loading && consent === 'pending'
}

export function shouldDeferProductOnboardingForAnalyticsConsent({
  analyticsConfigured,
  consent,
}: {
  analyticsConfigured: boolean
  consent: AnalyticsConsent
}) {
  return analyticsConfigured && consent === 'pending'
}
